import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

export const HeroContainer = styled.section`
  background: ${COLORS.cloud};
  position: relative;
  overflow: hidden;
`;

export const HeroInner = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 24px;
  ${mq({
    paddingTop: ['60px', '80px', '100px'],
    paddingBottom: ['60px', '80px', '100px'],
  })}
`;

export const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: center;
  ${mq({
    gridTemplateColumns: ['1fr', '1fr', '1fr 1fr'],
    gap: ['40px', '60px', '80px'],
  })}
`;

export const HeroTextColumn = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--M, 24px);
  ${mq({
    order: [2, 2, 1],
    width: ['100%', '100%', '444px'],
    marginLeft: ['0', '0', '157px'],
  })}
`;

export const HeroHeadline = styled.h1`
  color: var(--Typography-Panther, #000);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: Recoleta;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  ${mq({
    fontSize: ['32px', '36px', '45px'],
  })}
`;

export const HeroImageColumn = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  ${mq({
    order: [1, 1, 2],
    width: ['100%', '100%', '670px'],
    height: ['280px', 'auto', '440px'],
    marginRight: ['0', '0', '159px'],
    justifyContent: ['center', 'center', 'flex-end'],
  })}
`;

export const HeroImageWrapper = styled.div`
  width: 100%;
  max-width: 670px;
  aspect-ratio: 670/440;
  border-radius: var(--S, 18px);
  overflow: hidden;
  position: relative;
  z-index: 1;
  ${mq({
    maxWidth: ['100%', '670px', '670px'],
  })}
`;

export const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
